import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { NAVY, GOLD } from '../utils/constants';

const REFUND_MODES = ['Cash', 'Bank Transfer', 'Razorpay', 'GPay', 'ICICI POS'];

const todayInput = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};

export default function RefundModal({ booking, onClose, onSaved }) {
  const existing = !!booking.is_refunded;
  const [amount, setAmount]   = useState(existing ? String(booking.refund_amount || '') : String(booking.net_total || ''));
  const [mode, setMode]       = useState(existing ? (booking.refund_mode || '') : '');
  const [date, setDate]       = useState(existing ? (booking.refund_date || todayInput()) : todayInput());
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');

  const handleSave = async () => {
    if (!amount || !mode || !date) { setError('All fields required.'); return; }
    if (isNaN(Number(amount)) || Number(amount) <= 0) { setError('Enter a valid refund amount.'); return; }
    setSaving(true);
    const { error: err } = await supabase
      .from('bookings')
      .update({ is_refunded: true, refund_amount: Number(amount), refund_mode: mode, refund_date: date })
      .eq('id', booking.id);
    setSaving(false);
    if (err) { setError('Save failed: ' + err.message); return; }
    onSaved({ ...booking, is_refunded: true, refund_amount: Number(amount), refund_mode: mode, refund_date: date });
  };

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 400, padding: '24px 24px 20px', boxShadow: '0 8px 40px rgba(10,22,40,0.22)' }}>
        <h3 style={{ margin: '0 0 2px', fontSize: '1rem', fontWeight: 800, color: NAVY }}>
          {existing ? 'Edit Refund' : 'Mark as Refunded'}
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: '0.8rem', color: '#6b7280' }}>{booking.booking_name}</p>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#5a4a38', marginBottom: 4 }}>Refund Amount (₹)</label>
          <input
            type="number" min="0" value={amount}
            onChange={e => setAmount(e.target.value)}
            placeholder="0"
            style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #d8d0c0', borderRadius: 8, fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#5a4a38', marginBottom: 4 }}>Refund Mode</label>
          <select
            value={mode} onChange={e => setMode(e.target.value)}
            style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #d8d0c0', borderRadius: 8, fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box', background: '#fff' }}
          >
            <option value="">Select mode…</option>
            {REFUND_MODES.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#5a4a38', marginBottom: 4 }}>Refund Date</label>
          <input
            type="date" value={date} onChange={e => setDate(e.target.value)}
            style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #d8d0c0', borderRadius: 8, fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box', colorScheme: 'light' }}
          />
        </div>

        {error && <p style={{ color: '#dc2626', fontSize: '0.8rem', marginBottom: 14 }}>{error}</p>}

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={handleSave} disabled={saving}
            style={{ flex: 1, background: NAVY, color: GOLD, border: 'none', borderRadius: 8, padding: '9px 0', fontSize: '0.85rem', fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}
          >
            {saving ? 'Saving…' : (existing ? 'Update Refund' : 'Mark as Refunded')}
          </button>
          <button
            onClick={onClose}
            style={{ flex: 1, background: 'none', color: '#5a4a38', border: '1px solid #d8d0c0', borderRadius: 8, padding: '9px 0', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer' }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
